import { derivedStream } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { appModelStateEdit$ } from 'appModelStateEdit/appModelStateEdit$';
import { GetContentOptionsType } from 'appModelStateEdit/legacyTypes';
import { AppModelStateEditStreamShape } from 'appModelStateEdit/types';
import { fabVisibility$ } from '../fabVisibility$';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { type I18nLocale } from '@ardoq/i18n';

const toReferenceFabStream = ([isVisible, { options }, i18nLocale]: [
  boolean,
  AppModelStateEditStreamShape,
  I18nLocale,
]) => {
  return {
    isActive: options.type === GetContentOptionsType.CREATE_REFERENCE,
    isVisible,
    i18nLocale,
  };
};

const referenceFab$ = derivedStream(
  'referenceFab$',
  fabVisibility$,
  appModelStateEdit$,
  i18nLocale$
).pipe(map(toReferenceFabStream));

export { referenceFab$ };
